export default __webpack_public_path__ + "26fe9a66abcb3214472a7252efe372e6.webp";